import { useEffect, useState } from 'react';
import { ArchiveJournals } from '../components/ArchiveJournals';
import { ArchiveSearchBar } from '../components/ArchiveSearchBar';
import { SearchModal } from '../components/SearchModal';
import '../stylesheets/ArchivePage.css';
import axios from '../axios';

const cache = {
    years: null,
    journalsByYear: {},
    allJournals: null
};

export function ArchivePage() {
    const [years, setYears] = useState([]);
    const [journals, setJournals] = useState([]);
    const [currentJournal, setCurrentJournal] = useState([]);
    const [searchInput, setSearchInput] = useState('');
    const [searchedResults, setSearchedResults] = useState([]);
    const [modalOpened, setModalOpened] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadingData();
    }, [])

    async function loadingData() {
        let currentYears = cache.years;

        if (!currentYears) {
            let yearsResp = await axios.get('years');
            currentYears = [...yearsResp.data].reverse();
            cache.years = currentYears;
        }

        setYears(currentYears);

        const firstYear = currentYears[0]['year'];
        let journalsList = cache.journalsByYear[firstYear];

        if (!journalsList) {
            const journalsResp = await axios.get(`journals/year/${firstYear}`);
            journalsList = journalsResp.data;
            cache.journalsByYear[firstYear] = journalsList;
        }

        setJournals(journalsList);
        setCurrentJournal(journalsList[0]);
        setLoading(false);
    }

    async function onChangeSelect(event) {
        const selectedYear = event.target.value;

        let journalsList = cache.journalsByYear[selectedYear];

        if (!journalsList) {
            setLoading(true);
            const response = await axios.get(`journals/year/${selectedYear}`);
            journalsList = response.data;
            cache.journalsByYear[selectedYear] = journalsList;
            setLoading(false);
        }

        setJournals(journalsList);
        setCurrentJournal(journalsList[0]);
    }

    async function submitHandler(event) {
        event.preventDefault();

        if (searchInput) {
            const searchedText = searchInput.toLowerCase();

            if (!cache.allJournals) {
                const allJournalsResponse = await axios.get('journals');
                cache.allJournals = allJournalsResponse.data;
            }

            const allJournals = cache.allJournals;
            let filteredResults = [];

            allJournals.forEach(newspaper => {
                const newspaperResults = newspaper.content
                    .map(el => ({
                        url: newspaper.url,
                        year: newspaper.year,
                        title: newspaper.title,
                        ...el
                    }))
                    .filter(content => content.text.toLowerCase().includes(searchedText));

                filteredResults = filteredResults.concat(newspaperResults);
            });

            setModalOpened(true);
            setSearchedResults(filteredResults);
        }
    }

    return (
        <div className='ArchivePage'>
            {
                modalOpened && <SearchModal
                    setModalOpened={setModalOpened}
                    searchedResults={searchedResults}
                />
            }

            <ArchiveSearchBar
                years={years}
                serachInput={searchInput}
                submitHandler={submitHandler}
                onChangeSelect={onChangeSelect}
                setSearchInput={setSearchInput}
            />

            <ArchiveJournals
                journals={journals}
                loading={loading}
                currentJournal={currentJournal}
                setCurrentJournal={setCurrentJournal}
            />
        </div>
    )
}
